import { brand } from "@/constants/brandVariables/brandVariables";
import { Box, Flex, Text } from "@radix-ui/themes";
import { dataProps } from "@/models/data.model";
import { FC, JSX } from "react";

const NoChallengePlanned: FC<dataProps> = (): JSX.Element => {
  return (
    <Box height="100vh">
      <Box className="bg-img" />
      <Box className="bg__backdrop-top-left" />
      <Box className="bg__backdrop-top-right" />

      <Flex
        direction="column"
        align="center"
        justify="center"
        height="100%"
        gap="4"
        p="6"
      >
        <img src={brand.brandLogo} alt="" width={220} />

        <Flex direction="column" align="center" gap="2">
          <Text size="5" style={{ color: "#9e9d9d" }} align="center">
            No upcoming challenges are currently scheduled.
            <br />
            Check back soon.
          </Text>
        </Flex>
      </Flex>
    </Box>
  );
};

export default NoChallengePlanned;
